<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/promotion/promoAccount")
          i.fas.fa-list
          span.ml-1 {{ $t("ui.promotion") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(autofocus type="text" v-model="search" :placeholder="$t('message.search_by_id')" @enter="getPromoList(true)")
                div.col-md-1.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getPromoList(true)"
                    variant="success"
                    size="sm"
                    )
              //- div(v-if="isAdmin")
              div
                div.row.col-md-12
                  div(width="80%").mr-3
                    b-button(v-b-modal.addPromo type="button" variant="primary" size="sm")
                      i.fa.fa-plus
                      span {{ $t("ui.combine.add_promo") }}
                  div(width="20%")
        div.card-body
          div.mb-1
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.sticky-position(width="3%")
                        span #
                      th.sticky-position.sortable(width="9%" @click="sortOrder('promotion_id')")
                        span(:title="$t('ui.id')") {{ $t('ui.id') }}
                        i(:class="changeSortKey('promotion_id')")
                      th.sticky-position.sortable(width="9%" @click="sortOrder('promotion_name')")
                        span(:title="$t('ui.name')") {{ $t('ui.name') }}
                        i(:class="changeSortKey('promotion_name')")
                      th.sticky-position.sortable(width="8%" @click="sortOrder('claim_type')")
                        span(:title="$t('ui.claim_type')") {{ $t('ui.claim_type') }}
                        i(:class="changeSortKey('claim_type')")
                      th.sticky-position.sortable(width="8%" @click="sortOrder('min_deposit')")
                        span(:title="$t('ui.min_deposit')") {{ $t('ui.min_deposit') }}
                        i(:class="changeSortKey('min_deposit')")
                      th.sticky-position.sortable(width="8%" @click="sortOrder('bonus_rate')")
                        span(:title="$t('ui.bonus_rate')") {{ $t("ui.bonus_rate") }}
                        i(:class="changeSortKey('bonus_rate')")
                      th.sticky-position.sortable(width="8%" @click="sortOrder('max_bonus')")
                        span(:title="$t('ui.max_bonus')") {{ $t("ui.max_bonus") }}
                        i(:class="changeSortKey('max_bonus')")
                      th.sticky-position.sortable(width="8%" @click="sortOrder('rollover')")
                        span(:title="$t('ui.rollover')") {{ $t("ui.rollover") }}
                        i(:class="changeSortKey('rollover')")
                      th.sticky-position.sortable(width="8%" @click="sortOrder('criteria')")
                        span(:title="$t('ui.criteria')") {{ $t("ui.criteria") }}
                        i(:class="changeSortKey('criteria')")
                      th.sticky-position.text-center.sortable(width="6%" @click="sortOrder('status')")
                        span(:title="$t('ui.status')") {{ $t("ui.status") }}
                        i(:class="changeSortKey('status')")
                      th.text-right.sticky-position.sortable(width="10%" @click="sortOrder('start_date')")
                        span(:title="$t('ui.start_date')") {{ $t("ui.start_date") }}
                        i(:class="changeSortKey('start_date')")
                      th.text-right.sticky-position.sortable(width="10%" @click="sortOrder('end_date')")
                        span(:title="$t('ui.end_date')") {{ $t("ui.end_date") }}
                        i(:class="changeSortKey('end_date')")
                      th.text-center.sticky-position(width="6%")
                        span(:title="$t('ui.action')") {{ $t("ui.action") }}
                  tbody.clusterize-content
                    tr(v-if="promoAccountList.length == 0")
                      td(colspan="13").text-center
                        span {{ $t('message.no_data_available') }}
                    template(v-for="(item, index) in promoAccountList")
                      tr(:class="$helpers.rowClassBitPromo(item.status)")
                        td
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.promotion_id") {{ item.promotion_id }}
                        td
                          span(:title="item.promotion_name") {{ item.promotion_name }}
                        td
                          span(:title="item.claim_type") {{ item.claim_type }}
                        td
                          span(:title="$n(item.min_deposit, 'currency')") {{ $n(item.min_deposit, 'currency') }}
                        td
                          span(:title="$n(item.bonus_rate, 'currency')") {{ $n(item.bonus_rate, 'currency') }}
                        td
                          span(:title="$n(item.max_bonus, 'currency')") {{ $n(item.max_bonus, 'currency') }}
                        td
                          span(:title="$n(item.rollover, 'currency')") {{ $n(item.rollover, 'currency') }}
                        td
                          span(:title="item.criteria") {{ item.criteria }}
                        td
                          div.d-flex.justify-content-center.align-items-center
                            label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                              input.switch-input(type="checkbox" v-model="item.status" @change="changedStatus(item, $event)")
                              span.switch-slider(:data-checked='on' :data-unchecked='off')
                        td.text-right
                          span(:title="$moment(item.start_date).format('YYYY-MM-DD') + ', ' + item.start_time") {{ $moment(item.start_date).format('YYYY-MM-DD') + ', ' + item.start_time }}
                        td.text-right
                          span(:title="$moment(item.end_date).format('YYYY-MM-DD')") {{ $moment(item.end_date).format("YYYY-MM-DD") + ', ' + item.end_time }}
                        td.text-center
                          i.fa.ml-1(:title="$t('ui.detail')" size="sm" @click="onOffDetail(item)" :class="currId == item.promotion_id ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                      tr(v-if="isShowDetail == true && currId == item.promotion_id")
                        td(colspan="13")
                          table.tablex(style="width: 100%;")
                            thead
                              tr
                                th.text-center.sticky-position.sortable(width="9%")
                                  span(:title="$t('ui.withhold_bonus')") {{ $t("ui.withhold_bonus") }}
                                th.sticky-position.sortable(width="10%")
                                  span(:title="$t('ui.withhold_amount')") {{ $t("ui.withhold_amt") }}
                                th.sticky-position.sortable(width="13%")
                                  span(:title="$t('ui.max_withdraw_amount')") {{ $t("ui.max_withdraw_amt") }}
                                th.sticky-position(width="47%")
                                  span(:title="$t('ui.provider_list')") {{ $t("ui.provider_list") }}
                                th.sticky-position.text-center(width="3%")
                                  span(:title="$t('ui.monday')") {{ $t("ui.short.monday") }}
                                th.sticky-position.text-center(width="3%")
                                  span(:title="$t('ui.tuesday')") {{ $t("ui.short.tuesday") }}
                                th.sticky-position.text-center(width="3%")
                                  span(:title="$t('ui.wednesday')") {{ $t("ui.short.wednesday") }}
                                th.sticky-position.text-center(width="3%")
                                  span(:title="$t('ui.thursday')") {{ $t("ui.short.thursday") }}
                                th.sticky-position.text-center(width="3%")
                                  span(:title="$t('ui.friday')") {{ $t("ui.short.friday") }}
                                th.sticky-position.text-center(width="3%")
                                  span(:title="$t('ui.saturday')") {{ $t("ui.short.saturday") }}
                                th.sticky-position.text-center(width="3%")
                                  span(:title="$t('ui.sunday')") {{ $t("ui.short.sunday") }}
                            tbody.clusterize-content
                              tr
                                td.text-center
                                  span
                                    i(:class="{'fas fa-check text-info': item.withhold_bonus, 'fas fa-times text-warning': !item.withhold_bonus  }")
                                td
                                  span(:title="$n(item.withhold_amount, 'currency')") {{ $n(item.withhold_amount, 'currency') }}
                                td
                                  span(:title="$n(item.max_withdraw_amount, 'currency')") {{ $n(item.max_withdraw_amount, 'currency') }}
                                td
                                  span(:title="item.provider_list") {{ item.provider_list }}
                                td.text-center
                                  span
                                    i(:class="{'fas fa-check text-info': item.monday, 'fas fa-times text-warning': !item.monday  }")
                                td.text-center
                                  span
                                    i(:class="{'fas fa-check text-info': item.tuesday, 'fas fa-times text-warning': !item.tuesday  }")
                                td.text-center
                                  span
                                    i(:class="{'fas fa-check text-info': item.wednesday, 'fas fa-times text-warning': !item.wednesday  }")
                                td.text-center
                                  span
                                    i(:class="{'fas fa-check text-info': item.thursday, 'fas fa-times text-warning': !item.thursday  }")
                                td.text-center
                                  span
                                    i(:class="{'fas fa-check text-info': item.friday, 'fas fa-times text-warning': !item.friday  }")
                                td.text-center
                                  span
                                    i(:class="{'fas fa-check text-info': item.saturday, 'fas fa-times text-warning': !item.saturday  }")
                                td.text-center
                                  span
                                    i(:class="{'fas fa-check text-info': item.sunday, 'fas fa-times text-warning': !item.sunday  }")
    addpromo(@clicked="addPromo" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import addpromo from "@/components/promo/addPromo.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addpromo
  },
  data: () => ({
    loading: false,
    promoAccountList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "promotion_id",
    sortType: "asc",
    currId: null,
    isShowDetail: false
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    isAdmin() {
      return this.$store.getters.accountId == config.superUser;
    },
  },
  mounted: function() {
    this.getPromoList(true);
  },
  methods: {
    onOffDetail(item) {
      if (this.isShowDetail == true) {
        if (this.currId == item.promotion_id) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = false;
          this.currId = null;
          this.isShowDetail = true;
          this.currId = item.promotion_id;
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.promotion_id;
      }
    },
    sortOrder(key, type) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getPromoList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    addPromo: function() {
      this.search = "";
      this.getPromoList(true);

      this.$helpers.showDialog(this.$t("ui.combine.add_promo"), this.$t("message.success"), "success");
    },
    getPromoList: function(isSearch) {
      let url = config.promotionListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
      };


      if (this.search.trim() != '') {
        json.promotion_id = this.search.trim();
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.promoAccountList = response.data.dt;
                this.totalRow = this.promoAccountList.length > 0 ? this.promoAccountList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_promo_status_confirm", { name: item.promotion_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.promotionStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        promotion_id: item.promotion_id,
        new_status: status,
        audit_by: this.$store.getters.loginId
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getPromoList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getPromoList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getPromoList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>